import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { ApprovalRequest } from '../../../services/ApprovalService';

interface EntitySectionProps {
  approval: ApprovalRequest;
}

const EntitySection: React.FC<EntitySectionProps> = ({ approval }) => {
  if (!approval.entityId) return null;

  const isTicket =
    (approval.entityType || '').toLowerCase().includes('ticket') ||
    approval.entityId.startsWith('TK');
  const ticketHref = isTicket
    ? `/tickets/edit?id=${encodeURIComponent(approval.entityId)}`
    : null;

  return (
    <Paper
      elevation={0}
      sx={{ p: 2, backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 1.5 }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={2}>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography variant="caption" sx={{ color: '#64748b' }}>
            {approval.entityType || 'Entity'} · {approval.entityId}
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} sx={{ color: '#1e293b', mt: 0.25 }}>
            {approval.entityTitle || '(no title)'}
          </Typography>
          {approval.entityDescription && (
            <Typography variant="body2" sx={{ color: '#1e293b', mt: 1, whiteSpace: 'pre-wrap' }}>
              {approval.entityDescription}
            </Typography>
          )}
        </Box>
        {ticketHref && (
          <Button
            component={RouterLink}
            to={ticketHref}
            size="small"
            startIcon={<OpenInNew fontSize="small" />}
            sx={{ flexShrink: 0 }}
          >
            Open ticket
          </Button>
        )}
      </Stack>
    </Paper>
  );
};

export default EntitySection;
